module.exports = __webpack_public_path__ + "img/Kypho 960x1080.5f717eb1.png";